{
  "fr": {
    "ai": {
      "settings": {
        "title": "Paramètres IA",
        "description": "Configuration des fonctionnalités IA dans votre espace de travail.",
        "budget": {
          "title": "Budget mensuel",
          "description": "Plafond mensuel pour l'utilisation de l'IA (phase de test). Recalculé en fonction de la consommation de tokens sur toutes les conversations ce mois-ci.",
          "budget_label": "Budget",
          "usage_label": "Utilisé ce mois-ci",
          "save": "Enregistrer"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "Tous les projets",
        "empty_state": {
          "title": "Comment puis-je vous aider ?",
          "subtitle": "Posez-moi n'importe quelle question sur vos clients"
        },
        "suggestions": {
          "open_decisions": "Quelles décisions sont encore ouvertes ?",
          "unassigned_units": "Quelles units n'ont pas encore de client ?",
          "help_notifications": "Comment configurer les notifications ?",
          "help_project_settings": "Où trouver les paramètres du projet ?"
        },
        "input": {
          "placeholder": "Posez une question sur vos clients...",
          "hint": "Entrée pour envoyer · Maj+Entrée pour nouvelle ligne",
          "disclaimer": "Les résultats peuvent être inexacts. Vérifiez toujours les informations importantes."
        },
        "errors": {
          "generic": "Une erreur s'est produite. Veuillez réessayer.",
          "budget_reached": "Le budget mensuel de l'assistant IA pour cet espace a été atteint. Contactez un administrateur pour augmenter la limite."
        },
        "cap": {
          "message": "Vous avez atteint la limite de conversation.",
          "action": "Démarrer une nouvelle conversation"
        },
        "history": {
          "title": "Conversations passées",
          "empty": "Aucune conversation passée"
        },
        "support_cta": {
          "prompt": "Ce n'est pas la réponse que vous cherchiez ?",
          "action": "Contacter le support"
        }
      }
    }
  }
}
